export default __webpack_public_path__ + "static/media/pencil.135879a8.svg";